import { render, staticRenderFns } from "./UpdateWindowView.vue?vue&type=template&id=3963b3ba&scoped=true&"
import script from "./UpdateWindowView.vue?vue&type=script&lang=js&"
export * from "./UpdateWindowView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3963b3ba",
  null
  
)

export default component.exports